import { useEffect, useRef, useState } from "react";
import { Vendedor } from "../../../../types/vendedor";
import { useDispatch, useSelector } from "react-redux";
import { changeIntegranteState, IntegranteDisponible as IntegranteDisponibleType, selectCurrentCustomTeam, setNuevoIntegrante } from "../../../../store/equiposVentaSlice";
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import LooksOneRoundedIcon from '@mui/icons-material/LooksOneRounded';
import LooksTwoRoundedIcon from '@mui/icons-material/LooksTwoRounded';

interface Props {
    //integrante: Vendedor;
    integrante: IntegranteDisponibleType;
    equipoIndex: number;
}

export function IntegranteDisponible({ integrante, equipoIndex }: Props) {
    const [openMenu, setOpenMenu] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const [menuPosition, setMenuPosition] = useState<{ top: number; left: number; }>({
        top: 0,
        left: 0,
    });

    // redux shit
    const dispatch = useDispatch();
    const currentCustomTeam = useSelector(selectCurrentCustomTeam);

    const toggleModal = () => {
        if(!integrante.disponible)
            return;

        if(currentCustomTeam && currentCustomTeam.primerIntegrante && currentCustomTeam.primerIntegrante.equipoIndex == equipoIndex)
            return;

        if(currentCustomTeam && currentCustomTeam.segundoIntegrante && currentCustomTeam.segundoIntegrante.equipoIndex == equipoIndex)
            return;

        if(buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + window.scrollY + 2,
                left: rect.left + window.scrollX - 0,
            });
        }
        setOpenMenu(!openMenu);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if(menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)) {
            setOpenMenu(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    // redux shit
    const handleSelectIntegrante = (integrante: Vendedor, spot: "Primero" | "Segundo") => {
        // No seleccionar el mismo vendedor dos veces
        if(currentCustomTeam && currentCustomTeam.primerIntegrante && currentCustomTeam.primerIntegrante.id == integrante.id)
            return;
            
        if(currentCustomTeam && currentCustomTeam.segundoIntegrante && currentCustomTeam.segundoIntegrante.id == integrante.id)
            return;
        
        const newState = false;

        const nuevoIntegrante: IntegranteDisponibleType = {
            id: integrante.id,
            nombre: integrante.nombre,
            disponible: newState,
            tipo: integrante.tipo,
            equipoIndex,
        };
        dispatch(setNuevoIntegrante({ integrante: nuevoIntegrante, spot }));
        dispatch(changeIntegranteState({ indexTeam: equipoIndex, state: newState, integranteId: integrante.id }));
    }

    return (
        <>
        <div 
            ref={buttonRef}
            onClick={toggleModal}
            className={`flex items-center gap-x-1 border-2  hover:border-gray-600 rounded-md ${integrante.disponible ? "cursor-pointer border-slate-100" : "bg-gray-300 border-gray-600 cursor-default"}`}>
            <Person2RoundedIcon sx={{ width: 20, height: 20 }}/>
            <div className="flex gap-x-3 justify-between w-full">
                <p>{integrante.nombre}</p>
                <p className={`h-[24px] text-sm border-2 ${integrante.tipo == "Odontólogos" ?"border-green-700 bg-green-100" : "border-purple-700 bg-purple-100"} px-1 rounded-full`}>{integrante.tipo}</p>
            </div>
        </div>

        {openMenu && (
            <div
                ref={menuRef}
                className="absolute bg-white shadow-lg border border-gray-300 rounded p-2 z-50"
                style={{ top: menuPosition.top, left: menuPosition.left }}>
                <div
                    onClick={() => {
                        console.log("Integrante 1 seleccionado como integrante 1", integrante.nombre)
                        handleSelectIntegrante(integrante, "Primero")
                        setOpenMenu(false);
                    }}
                    className="flex gap-x-1 items-center hover:bg-gray-200 rounded-[3px] py-[3px] cursor-pointer">
                    <LooksOneRoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p className="text-sm font-semibold text-center">Seleccionar como primer integrante</p>
                </div>

                <div
                    onClick={() => {
                        console.log("Integrante 1 seleccionado como integrante 2", integrante.nombre)
                        handleSelectIntegrante(integrante, "Segundo")
                        setOpenMenu(false);
                    }}
                    className="flex gap-x-1 items-center hover:bg-gray-200 rounded-[3px] py-[3px] cursor-pointer">
                    <LooksTwoRoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p className="text-sm font-semibold text-center">Seleccionar como segundo integrante</p>
                </div>
            </div>
        )}
        </>
    );
}
